export default __webpack_public_path__ + "static/media/466.b7bc1640.jpg";